import { render } from "./print-pr.vue?vue&type=template&id=5a1a7421&scoped=true"
import script from "./print-pr.vue?vue&type=script&lang=js"
export * from "./print-pr.vue?vue&type=script&lang=js"

import "./print-pr.vue?vue&type=style&index=0&id=5a1a7421&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1a7421"]])

export default __exports__